/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
/* ------------------------------------------------------------------------------------------------------------
 * WIDGETS FLUTUANTES DE APPS vs BARRA STICKY DE COMPRA
 * ------------------------------------------------------------------------------------------------------------
 *
 * Os widgets ancorados no canto inferior — RD Station (WhatsApp, z-index 900) e Bonifiq (pontos, z-index
 * 2147483646) — ficam muito acima da barra sticky de compra (z-index 10) e cobriam o preço e o botão "Comprar"
 * no mobile. Aqui eles sobem a altura da barra enquanto ela está visível, de modo que os três fiquem clicáveis.
 *
 * Por que `top` e não `bottom`/`transform`: os dois apps posicionam por `top` calculado em runtime, então
 * sobrescrever `bottom` não tem efeito. E o widget do Bonifiq ignora tanto `transform` quanto `translate` —
 * medido na página: só `top` desloca os dois.
 *
 * O deslocamento é incremental — guardamos quantos pixels já aplicamos e movemos só a diferença. Não dá para
 * limpar o nosso `top` e reler o do app antes de cada ajuste: o RD escreve o `top` dele inline, no mesmo lugar,
 * então um removeProperty apagaria o valor do app junto e os widgets não voltariam ao lugar.
 *
 * Fonte da altura (ambas gravadas em document.documentElement.style):
 *   --cart-notification-offset : publicada pelo Focal para a barra do snippet product-sticky-form
 *   --sticky-atc-offset        : publicada pela section sticky-add-to-cart, quando estiver habilitada
 */
(() => {
  const SELETOR_WIDGETS = '.rdstation-popup-position-bottom_right, section.bonifiq-widget-section';

  const alturaDaBarraVisivel = () => {
    const raiz = getComputedStyle(document.documentElement);

    return Math.max(
      parseFloat(raiz.getPropertyValue('--cart-notification-offset')) || 0,
      parseFloat(raiz.getPropertyValue('--sticky-atc-offset')) || 0
    );
  };

  const deslocamentoAplicado = new WeakMap();
  const usaTopInline = new WeakMap();

  const aplicarDeslocamento = () => {
    const altura = alturaDaBarraVisivel();

    document.querySelectorAll(SELETOR_WIDGETS).forEach((widget) => {
      // Na primeira passada, registra de onde vem o `top` do widget. O RD escreve
      // inline (não podemos apagar, é o valor dele); o Bonifiq vem da folha de
      // estilo do app, e aí remover o nosso é o jeito confiável de restaurar.
      if (!usaTopInline.has(widget)) {
        usaTopInline.set(widget, widget.style.top !== '');
      }

      // Bonifiq aberto vira um card de 650px — subir jogaria o topo dele para fora da tela.
      const alvo = widget.classList.contains('active') ? 0 : altura;
      const jaAplicado = deslocamentoAplicado.get(widget) || 0;

      if (alvo === jaAplicado) return;

      if (alvo === 0 && !usaTopInline.get(widget)) {
        widget.style.removeProperty('top');
        deslocamentoAplicado.set(widget, 0);
        return;
      }

      const topoAtual = parseFloat(getComputedStyle(widget).top);
      if (Number.isNaN(topoAtual)) return;

      widget.style.setProperty('top', topoAtual - (alvo - jaAplicado) + 'px', 'important');
      deslocamentoAplicado.set(widget, alvo);
    });
  };

  // O atributo style da raiz muda a cada transição de estado da barra.
  new MutationObserver(aplicarDeslocamento).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['style']
  });

  // O Bonifiq alterna a classe `active` ao abrir o painel; precisamos reagir a isso.
  const observarClasseDoBonifiq = () => {
    const bonifiq = document.querySelector('section.bonifiq-widget-section');
    if (!bonifiq || bonifiq.dataset.observadoPeloTema) return;

    bonifiq.dataset.observadoPeloTema = 'sim';
    new MutationObserver(aplicarDeslocamento).observe(bonifiq, {
      attributes: true,
      attributeFilter: ['class']
    });
  };

  const sincronizar = () => {
    observarClasseDoBonifiq();
    aplicarDeslocamento();
  };

  // Os apps injetam os widgets depois do load — reagir à entrada deles no body.
  new MutationObserver(sincronizar).observe(document.body, { childList: true });

  window.addEventListener('resize', sincronizar);
  document.addEventListener('DOMContentLoaded', sincronizar);
})();
